import { Box, Heading, Text } from "@radix-ui/themes";
import i18next from "i18next";
import React from "react";

interface Props {
  client: string;
}

const ChallengeTerms: React.FC<Props> = ({ client }) => {
  return (
    <Box>
      <Heading as="h4" size="3" mb="0">
        {i18next.t("challenge.terms.heading")}
      </Heading>
      <Text size="2" color="gray">
        {i18next.t("challenge.terms.desc")}
      </Text>
    </Box>
  );
};

export default ChallengeTerms;
